import { BellIcon, CheckCircleIcon, ExclamationTriangleIcon, InformationCircleIcon } from '@heroicons/react/24/outline';
import { CheckIcon } from '../../../../icons/SvgIcons';

type NotificationType = "USER_ACTION" | "INFORMATIVE" | "ALERT" | "SUCCESS";

type NotificationIconProps = {
  type: NotificationType;
  actorName?: string | null;
};

const getInitials = (name: string | null | undefined): string => {
  if (!name) return '';
  const names = name.trim().split(' ');
  if (names.length === 1) {
    return names[0].charAt(0).toUpperCase();
  }
  return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
};

export function NotificationIcon({ type, actorName }: NotificationIconProps) {
  const getIconContent = () => {
    switch (type) {
      case 'USER_ACTION':
        return (
          <span className="text-gray-800 text-sm font-normal">
            {getInitials(actorName)}
          </span>
        );
      case 'INFORMATIVE':
        return <InformationCircleIcon className="w-5 h-5 text-purple-600" />;
      case 'ALERT':
        return <ExclamationTriangleIcon className="w-5 h-5 text-rose-600" />;
      case 'SUCCESS':
        return CheckIcon('#027A69');
      default:
        return <BellIcon className="w-5 h-5 text-gray-600" />;
    }
  };

  const getBackgroundColor = () => {
    switch (type) {
      case 'USER_ACTION':
        return 'bg-gray-100';
      case 'INFORMATIVE':
        return 'bg-purple-100';
      case 'ALERT':
        return 'bg-rose-100';
      case 'SUCCESS':
        return 'bg-cyan-100';
      default:
        return 'bg-gray-100';
    }
  };

  return (
    <div
      className={`min-w-8 h-8 rounded-full flex items-center justify-center ${getBackgroundColor()}`}
    >
      {getIconContent()}
    </div>
  );
}

